import ExperienceChip from './ExperienceChip';

export default ExperienceChip;
